// CSS columns move horizontally, even though the preview shows one page at a
// time. Subtract the flow origin to cancel the current page offset and zoom.
export const getHandoutSectionPreviewPage = (flow, sections, sectionId, stride) => {
  if (!flow || !(stride > 0)) return null;
  const bounds = flow.getBoundingClientRect();
  const width = flow.offsetWidth || parseFloat(getComputedStyle(flow).width);
  const scale = bounds.width / width;
  if (!(scale > 0)) return null;
  const nodes = Array.from(flow.querySelectorAll('[data-handout-section-id]'));
  const index = sections.findIndex((section) => section.id === sectionId);
  if (index < 0) return null;
  // Disabled/merged breaks and empty sections do not have a rendered box. Use
  // the next visible block, or the last fragment before an end-of-document break.
  const candidates = [...sections.slice(index).map((section) => [section.id, false]),
    ...sections.slice(0, index).reverse().map((section) => [section.id, true])];
  for (const [id, previous] of candidates) {
    const matches = nodes.filter((node) => node.getAttribute('data-handout-section-id') === id);
    const rects = matches.flatMap((node) => Array.from(node.getClientRects()))
      .filter((rect) => rect.width > 0 && Number.isFinite(rect.left));
    const rect = previous ? rects[rects.length - 1] : rects[0];
    if (rect) return Math.max(0, Math.floor((rect.left - bounds.left) / scale / stride + .01));
  }
  return null;
};

// Page (0-based) holding the nth rendered copy of a question, measured the
// same way as sections so zoom and the current page offset cancel out.
export const getHandoutQuestionPreviewPage = (flow, questionId, stride, occurrence = 0) => {
  if (!flow || !questionId || !(stride > 0)) return null;
  const bounds = flow.getBoundingClientRect();
  const width = flow.offsetWidth || parseFloat(getComputedStyle(flow).width);
  const scale = bounds.width / width;
  if (!(scale > 0)) return null;
  const nodes = Array.from(flow.querySelectorAll('[data-preview-question-id]'))
    .filter((node) => node.getAttribute('data-preview-question-id') === String(questionId));
  const node = nodes[occurrence] || nodes[0];
  const rect = node && Array.from(node.getClientRects()).find((item) => item.width > 0 && Number.isFinite(item.left));
  if (!rect) return null;
  return Math.max(0, Math.floor((rect.left - bounds.left) / scale / stride + .01));
};
